import React from 'react';
import throttle from 'lodash/throttle';
const THROTTLE_TIMEOUT = 100;
class ElementQueries extends React.Component {
    componentDidMount() {
        this.setBreakpoints();
        window.addEventListener('resize', this.setBreakpoints);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.setBreakpoints);
    }
    render() {
        const { id , children , width , className  } = this.props;
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            ref: this.saveRootRef,
            "data-min-width": width && this.getMinWidthAttrValue(width),
            "data-max-width": width && this.getMaxWidthAttrValue(width),
            className: className
        }, children);
    }
    constructor(...args){
        super(...args);
        this.saveRootRef = (node)=>{
            this.rootRef = node;
            const { forwardedRef  } = this.props;
            if (forwardedRef) {
                if (typeof forwardedRef === 'function') {
                    forwardedRef(node);
                } else {
                    forwardedRef.current = node;
                }
            }
        };
        this.getMinWidthAttrValue = (elementWidth)=>{
            const minWidth = this.props.widthBreakpoints.filter((width)=>width <= elementWidth);
            return minWidth.join(' ');
        };
        this.getMaxWidthAttrValue = (elementWidth)=>{
            const maxWidth = this.props.widthBreakpoints.filter((width)=>width >= elementWidth);
            return maxWidth.join(' ');
        };
        this.setBreakpoints = throttle(()=>requestAnimationFrame(()=>{
                if (!this.rootRef) {
                    return;
                }
                const sizes = this.rootRef.getBoundingClientRect();
                this.rootRef.setAttribute('data-max-width', this.getMaxWidthAttrValue(sizes.width));
                this.rootRef.setAttribute('data-min-width', this.getMinWidthAttrValue(sizes.width));
                this.props.onSettled && this.props.onSettled();
            }), THROTTLE_TIMEOUT);
    }
}
export { ElementQueries as default };
